const BASE_API_ENDPOINT = "/apps/rta-b2b";
const SORTING_QP = "sort=desc";

// Customer Profile
export const GET_CUSTOMER_PROFILE_API_ENDPOINT = `${BASE_API_ENDPOINT}/customers/profile`;

// Orders Endpoints
export const GET_ORDERS_API_ENDPOINT = `${BASE_API_ENDPOINT}/orders?${SORTING_QP}`;
export const GET_ORDER_DETAILS_API_ENDPOINT = (orderId: string) =>
    `${BASE_API_ENDPOINT}/orders/${orderId}`;
export const GET_ORDER_DETAILS_LIST_API_ENDPOINT = (documentId: string) =>
    `${BASE_API_ENDPOINT}/orders/${documentId}/rows?${SORTING_QP}`;

// Invoices Endpoints
export const GET_INVOICES_API_ENDPOINT = `${BASE_API_ENDPOINT}/sales-invoices?${SORTING_QP}`;
export const GET_INVOICE_DETAILS_API_ENDPOINT = (invoiceId: string) =>
    `${BASE_API_ENDPOINT}/sales-invoices/${invoiceId}`;
export const GET_INVOICE_DETAILS_LIST_API_ENDPOINT = (documentId: string) =>
    `${BASE_API_ENDPOINT}/sales-invoices/${documentId}/rows?${SORTING_QP}`;

// DDTs Endpoints
export const GET_DDTS_API_ENDPOINT = `${BASE_API_ENDPOINT}/sales-shipments?${SORTING_QP}`;
export const GET_DDT_DETAILS_API_ENDPOINT = (ddtId: string) =>
    `${BASE_API_ENDPOINT}/sales-shipments/${ddtId}`;
export const GET_DDT_DETAILS_LIST_API_ENDPOINT = (documentId: string) =>
    `${BASE_API_ENDPOINT}/sales-shipments/${documentId}/rows?${SORTING_QP}`;

// Credit Memos Endpoints
export const GET_CREDIT_NOTES_API_ENDPOINT = `${BASE_API_ENDPOINT}/sales-credit-memos?${SORTING_QP}`;
export const GET_CREDIT_NOTE_DETAILS_API_ENDPOINT = (creditNoteId: string) =>
    `${BASE_API_ENDPOINT}/sales-credit-memos/${creditNoteId}`;
export const GET_CREDIT_NOTE_DETAILS_LIST_API_ENDPOINT = (documentId: string) =>
    `${BASE_API_ENDPOINT}/sales-credit-memos/${documentId}/rows?${SORTING_QP}`;

// Stores Endpoints
export const GET_STORES_API_ENDPOINT = `${BASE_API_ENDPOINT}/b2b-products`;
export const SEND_STORE_ORDER_API_ENDPOINT = `${BASE_API_ENDPOINT}/orders`;

// Rma Endpoints
export const SEND_RMA_API_ENDPOINT = `${BASE_API_ENDPOINT}/complaints`;
